import { sha256 } from 'js-sha256';

import { AnswerCardType, QueryIntent } from './constants';

export const sha256Hash = (str: string): string => sha256(str);

export const extractUrlHostname = (sourceUrl: string) => {
	let url;
	try {
		url = new URL(sourceUrl);
	} catch {
		return undefined;
	}
	return url.hostname;
};

export const isHello = (cloudId: string): boolean => {
	return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};

export const getAnswerCardType = (
	isReadingAids: boolean,
	smartAnswersRoute?: QueryIntent,
): AnswerCardType => {
	if (isReadingAids) {
		return AnswerCardType.DEFINITION;
	}

	switch (smartAnswersRoute) {
		case QueryIntent.PERSON:
			return AnswerCardType.PERSON;
		case QueryIntent.TEAM:
			return AnswerCardType.TEAM;
		case QueryIntent.AGENT:
			return AnswerCardType.AGENT;
		case QueryIntent.DATE:
			return AnswerCardType.DATE;
		case QueryIntent.LOCATION:
			return AnswerCardType.LOCATION;
		case QueryIntent.TOPIC:
			return AnswerCardType.TOPIC;
		case QueryIntent.JIRA_NATURAL_LANGUAGE_QUERY:
			return AnswerCardType.JIRA_NATURAL_LANGUAGE_QUERY;
		case QueryIntent.JIRA_ISSUE:
			return AnswerCardType.JIRA_ISSUE;
		case QueryIntent.NAV_CONTENT:
			return AnswerCardType.NAV_CONTENT;
		case QueryIntent.ORG_CHART:
			return AnswerCardType.ORG_CHART;
		case QueryIntent.NAVIGATIONAL:
			return AnswerCardType.NAVIGATIONAL;
		case QueryIntent.NONE:
			return AnswerCardType.NONE;
		case QueryIntent.DEFAULT:
			return AnswerCardType.DEFAULT;
		case QueryIntent.NATURAL_LANGUAGE_QUERY:
		case QueryIntent.KEYWORD_OR_ACRONYM:
		default:
			return AnswerCardType.SAIN;
	}
};
